<template>
    <div class="container">
        <div class="header-nav">
            <headerComp></headerComp>
        </div>
        <div>
            <section1></section1>
        </div>
        <div>
            <section2></section2>
        </div>
        <div>
            <section3></section3>
        </div>
        <div>
            <section4></section4>
        </div>
        <div>
            <section5></section5>
        </div>
        <div>
            <section6></section6>
        </div>
        <div>
            <footerComp></footerComp>
        </div>
    </div>
</template>

<script>


import headerComp from '@/components/header.vue';
import footerComp from '@/components/footer.vue';
import section1 from '@/components/home-section-1.vue';
import section2 from '@/components/home-section-2.vue';
import section3 from '@/components/home-section-3.vue';
import section4 from '@/components/home-section-4.vue';
import section5 from '@/components/home-section-5.vue';
import section6 from '@/components/home-section-6.vue';

export default {
    "name": "home-page",
    components:{
        headerComp,
        section1,
        section2,
        section3,
        section4,
        section5,
        section6,
        footerComp
    },
    setup() {

    },
}
</script>

<style lang="scss" scoped>

@import '@/styles/shared.scss';


.container{
    width: 100vw;
    overflow: hidden;
}

.header-nav{
    margin-bottom: 1%;
}





</style>